<template>

  <el-form :inline="true">

    <el-form-item prop="powerReq" label="Requires">
      <el-input v-model="power.powerReq" placeholder="Power Kw/H" :disabled="!this.isEdit">
        <template #append>Kw/H</template>
      </el-input>
    </el-form-item>

  </el-form>

</template>


<script>

export default {

  props: {
    rowData: {
      type: Object,
      required: true
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      power: this.rowData
    }
  } // data
}
</script>
